'use client'

import { use } from 'react'
import { PlatformEventNotificationMessage } from '../../../../../MyStichtingOpenHelpers/src/static'
import { SSENotificationTypes, SSETypes } from '../../../types'
import { NotificationContext } from '../notification-provider'

export const useSetPlatformEventNotification = () => {
    const { success, warning, error, info } = use(NotificationContext)

    const setNotification = (data: PlatformEventNotificationMessage) => {
        if (data.type === SSETypes.RESPONSE) return

        switch (data.infoType) {
            case SSENotificationTypes.SUCCESS:
                success({ title: data.title, message: data.message ?? '' })
                break
            case SSENotificationTypes.WARNING:
                warning({ title: data.title, message: data.message ?? '' })
                break
            case SSENotificationTypes.ERROR:
                error({ title: data.title, message: data.message ?? '' })
                break
            case SSENotificationTypes.INFO:
            default:
                info({ title: data.title, message: data.message ?? '' })
        }
    }

    return { setNotification }
}
